import React from 'react';
import { Flex, Text } from '@applyboard/crystal-ui';
import { useScholarshipPageContext } from "../../contexts";
import { PageSectionTitle } from "../PageSectionTitle";
import { consts } from "../utils";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ScholarshipAdminNote = function ScholarshipAdminNote() {
  var _useScholarshipPageCo = useScholarshipPageContext(),
    scholarship = _useScholarshipPageCo.scholarship;

  // Admin_notes:
  // - if undefined -> admin note is not accessible to the current user
  // - if null or empty string -> admin note is accessible to the user but there is no notes
  var showAdminNotes = scholarship.adminNotes !== undefined;
  if (!showAdminNotes) {
    return null;
  }
  return _jsxs(Flex, {
    direction: "column",
    gap: 2,
    children: [_jsx(PageSectionTitle, {
      title: "Admin notes"
    }), _jsx(Text, {
      children: scholarship.adminNotes || consts.noAdminNotes
    })]
  });
};